module.exports = __webpack_public_path__ + "fonts/interactive.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.woff
// module id = 9
// module chunks = 0